import Navigation from "@/components/Navigation";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";

export default {
  components: {
    Navigation,
    SiteHeader,
    SiteFooter
  },

  data() {
    return {
      loading: true,
      navigation: null,
      header: null,
      footer: null,
      doc: null
    };
  },

  watch: {
    $route(id) {
      this.update();
    },
    "doc.header_select"() {
      this.update();
    },
    "doc.footer_select"() {
      this.update();
    },
    "doc.nav_select"() {
      this.update();
    }
  },

  methods: {
    update() {
      this.loading = true;
      this.$uri(this.$route.path, response => {
        if (!response) return;

        window.currentDoc = response;

        this.doc = response;
        this.loading = false;

        this.navigation = null;
        this.header = null;
        this.footer = null;

        var headerSelect = this.doc.header_select;
        headerSelect == "custom"
          ? (this.header = this.doc)
          : headerSelect == "inherit"
          ? $.getJSON(
              this.endpoint + "/header?url=" + this.$route.path,
              response => {
                this.header = response;
              }
            )
          : null;

        var navSelect = this.doc.nav_select;
        navSelect == "custom"
          ? (this.navigation = this.doc)
          : navSelect == "inherit"
          ? $.getJSON(
              this.endpoint + "/navigation?url=" + this.$route.path,
              response => {
                this.navigation = response;
              }
            )
          : null;

        var footerSelect = this.doc.footer_select;
        footerSelect == "custom"
          ? (this.footer = this.doc)
          : footerSelect == "inherit"
          ? $.getJSON(
              this.endpoint + "/footer?url=" + this.$route.path,
              response => {
                this.footer = response;
              }
            )
          : null;
      });
    }
  },

  created() {
    this.update();
  }
};



// WEBPACK FOOTER //
// ./src/mixins/site.js